import React from "react";

import { Modal } from "antd";
import { styled } from '@mui/material/styles';
import MuiToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import DigitalIcon from "../../../../../assets/images/custom/digital_icon.svg";
import CloseIcon from "../../../../../assets/images/custom/close_icon.svg";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

const styles = {
  unselected: {
    marginTop: "32px",
    width: "176px",
    backgroundColor: "#28b6c74c",
    borderRadius: "10px",
    borderStyle: "none"
  },
  selectedStripe: {
    display: "inline-block",
    height: "30px",
    backgroundColor: "#28b6c7"
  },
  unselectedStripe: {
    display: "inline-block",
    height: "30px",
    backgroundColor: "#28b6c74c"
  },
  varTextArea: {
    marginTop: "40px",
    textAlign: "left"
  },
  selectedText: {
    display: "inline-block",
    width: "80px",
    fontSize: "24px",
    color: "#ffffff",
    textAlign: "center"
  },
  unselectedText: {
    display: "inline-block",
    width: "80px",
    fontSize: "16px",
    color: "#ffffff",
    textAlign: "center"
  },
  selectedToggleText: {
    textTransform: "none",
    color: "#ffffff",
    fontSize: "16px"
  },
  unselectedToggleText: {
    textTransform: "none",
    color: "#ffffffb3",
    fontSize: "16px"
  }
};

const ToggleButton = styled(MuiToggleButton) ({
  "&.Mui-selected, &:hover": {
    backgroundColor: "#28b6c780 !important",
    borderRadius: "10px",
    borderStyle: "none"
  }
});

export function DigitalChVarSelect(props) {
  const { when, onOK, onCancel, chNo, chName, setSelectedVar, selectedVar, varOptions } = props;
  const [var1, var2] = varOptions;
  const handleVars = (event, newVar) => {
    if (newVar !== null ){
      setSelectedVar(newVar);
    }
  };

  return (
    <Modal
      title={
        <Box 
          component={"p"} 
          sx={{        
              color: "#ffffff",
              fontSize: "24px",
              fontWeight: "400"
            }}
        >
          {"Which variable should be visible in the graph?"}
        </Box>
      }
      open={when}
      cancelText="Cancel"
      okText="Confirm"
      onOk={onOK}
      onCancel={onCancel}
      width={980}
      height={590}
      closeIcon={<img src={CloseIcon} />}
      okButtonProps={{
        type: "primary",
        style: {
          color: "#ffffff",
          fontSize: "16px",
          fontWeight: "500",
          backgroundColor: "#28b6c7",
          borderRadius: "5px",
          marginRight: "50px",
          textAlign: "center",
          width: "172px",
          height: "43px"
        },
      }}
      cancelButtonProps={{
        type: "link",
        style: {
          color: "#19b2ab",
          fontSize: "16px",
          fontWeight: "500",
        },
      }}
      maskClosable={false}
      style={{
        backgroundColor: "#161a1e",
        color: "#ffffff",
        paddingBottom: 0,
        top: "165px", 
      }}
      styles={{
        content: {
          backgroundColor: "unset",
          textAlign: "center",
          padding: "76px 120px",
        },
        header:{
          backgroundColor: "unset",
        },
        footer:{
          textAlign: "center",
          marginTop: "60px",
        }
      }}
    >
      <Box 
        component={"div"}
        sx={{ 
          display: "inline-block",
          borderRadius: "5px",
          border: "1px solid rgba(132, 235, 128, 0.7)",
          padding: "8px 16px 8px 16px",
          backgroundColor: "#252d39",
          marginTop: "30px"
        }}
      >
        <Box component={"img"} src={DigitalIcon} sx={{ marginBottom: "-2.5px" }}/>
        <Box component={"span"} sx={{ marginLeft: "5px", fontSize: "16px" }}> {chNo} </Box>
        <Box component={"span"} sx={{ marginLeft: "5px", fontSize: "16px" }}> {chName} </Box>
      </Box>
      <div>
        <ToggleButtonGroup
          value={selectedVar}
          exclusive
          onChange={handleVars}
          aria-label="selectedVar"
        >
          <ToggleButton value={var1} aria-label="var1" sx={styles.unselected}>
            <Box component={"div"} sx={selectedVar == var1 ? styles.selectedToggleText : styles.unselectedToggleText}>{`Show "${var1}"`}</Box>
          </ToggleButton>
          <ToggleButton value={var2} aria-label="var2" sx={styles.unselected}>
            <Box component={"div"} sx={selectedVar == var2 ? styles.selectedToggleText : styles.unselectedToggleText}>{`Show "${var2}"`}</Box>
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      <Box sx={styles.varTextArea}>
        <Box component={"span"} sx={selectedVar == var1 ? styles.selectedText : styles.unselectedText}>{var1}</Box>
        <Box component={"span"} sx={selectedVar == var2 ? styles.selectedText : styles.unselectedText}>{var2}</Box>
      </Box>
      <Box 
        style={{ width: "80px" }} 
        sx={selectedVar == var1 ? styles.selectedStripe : styles.unselectedStripe}>
      </Box>
      <Box
        style={{ width: "80px" }}
        sx={selectedVar == var2 ? styles.selectedStripe : styles.unselectedStripe}>
      </Box>
      <Box 
        style={{ width: "150px" }} 
        sx={selectedVar == var1 ? styles.selectedStripe : styles.unselectedStripe}>
      </Box>
      <Box
        style={{ width: "130px" }}
        sx={selectedVar == var2 ? styles.selectedStripe : styles.unselectedStripe}>
      </Box>
      <Box 
        style={{ width: "120px" }} 
        sx={selectedVar == var1 ? styles.selectedStripe : styles.unselectedStripe}>
      </Box>
      <Box
        style={{ width: "180px" }}
        sx={selectedVar == var2 ? styles.selectedStripe : styles.unselectedStripe}>
      </Box>
    </Modal>
  );
}

DigitalChVarSelect.propTypes = {
  when: PropTypes.bool,
  onOK: PropTypes.func,
  onCancel: PropTypes.func,
  chNo: PropTypes.string,
  chName: PropTypes.string,
  setSelectedVar: PropTypes.func,
  selectedVar: PropTypes.string,
  varOptions: PropTypes.arrayOf(PropTypes.string),
}